import React from 'react';
import './StatusBadge.css';

/**
 * StatusBadge — unified compliance status pill used across all safety modules.
 * status: 'compliant' | 'due-soon' | 'overdue' | 'not-tested' | 'in-progress' | 'active' | 'inactive' | 'pending' | string
 */
const StatusBadge = ({ status, label, size = 'sm', dot = false, className = '' }) => {
  const normalised = (status || '').toLowerCase().replace(/\s+/g, '-');

  const map = {
    'compliant':    { cls: 'sb-green',   text: 'Compliant' },
    'pass':         { cls: 'sb-green',   text: 'Pass' },
    'passed':       { cls: 'sb-green',   text: 'Passed' },
    'active':       { cls: 'sb-green',   text: 'Active' },
    'complete':     { cls: 'sb-green',   text: 'Complete' },
    'completed':    { cls: 'sb-green',   text: 'Completed' },
    'due-soon':     { cls: 'sb-amber',   text: 'Due Soon' },
    'due':          { cls: 'sb-amber',   text: 'Due' },
    'pending':      { cls: 'sb-amber',   text: 'Pending' },
    'in-progress':  { cls: 'sb-amber',   text: 'In Progress' },
    'review':       { cls: 'sb-amber',   text: 'Review' },
    'overdue':      { cls: 'sb-red',     text: 'Overdue' },
    'fail':         { cls: 'sb-red',     text: 'Fail' },
    'failed':       { cls: 'sb-red',     text: 'Failed' },
    'expired':      { cls: 'sb-red',     text: 'Expired' },
    'critical':     { cls: 'sb-red',     text: 'Critical' },
    'not-tested':   { cls: 'sb-gray',    text: 'Not Tested' },
    'unknown':      { cls: 'sb-gray',    text: 'Unknown' },
    'inactive':     { cls: 'sb-gray',    text: 'Inactive' },
    'n/a':          { cls: 'sb-gray',    text: 'N/A' },
    'info':         { cls: 'sb-blue',    text: 'Info' },
    'scheduled':    { cls: 'sb-blue',    text: 'Scheduled' },
    'low':          { cls: 'sb-blue',    text: 'Low' },
    'medium':       { cls: 'sb-amber',   text: 'Medium' },
    'high':         { cls: 'sb-red',     text: 'High' },
    // Compliance protection states
    'legal-hold':   { cls: 'sb-hold',    text: 'Legal Hold' },
    'frozen':       { cls: 'sb-frozen',  text: 'Frozen' },
    'audit-locked': { cls: 'sb-locked',  text: 'Audit Locked' },
    'immutable':    { cls: 'sb-teal',    text: 'Immutable' },
    'protected':    { cls: 'sb-locked',  text: 'Protected' },
    'archived':     { cls: 'sb-gray',    text: 'Archived' },
    'recalled':     { cls: 'sb-red',     text: 'Recalled' },
  };

  const entry = map[normalised] || { cls: 'sb-gray', text: status || '—' };
  const displayText = label || entry.text;

  return (
    <span className={`status-badge status-badge-${size} ${entry.cls} ${className}`}>
      {dot && <span className="sb-dot" />}
      {displayText}
    </span>
  );
};

export default StatusBadge;
